//#region Libraries
import styled from "styled-components";
import ResourceScheduleActivityCard from "views/Recursos/components/ResourceScheduleActivityCard";
//#endregion

const LibraryScheduleActivityCard = styled(ResourceScheduleActivityCard)`
    /*Aquí va el CSS específico para solo las cards de la grilla de "Biblioteca"*/
`;

export default LibraryScheduleActivityCard;